import { render, staticRenderFns } from "./EncuestaSatisfaccionPage.vue?vue&type=template&id=4b922cbd&scoped=true&"
import script from "./EncuestaSatisfaccionPage.vue?vue&type=script&lang=js&"
export * from "./EncuestaSatisfaccionPage.vue?vue&type=script&lang=js&"
import style0 from "./EncuestaSatisfaccionPage.vue?vue&type=style&index=0&id=4b922cbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b922cbd",
  null
  
)

export default component.exports